import { ABSOLUTE_LINK_DOMAIN_STRIPPING_240201 } from "@faire/web-api--source/indigofair/settings/ABSOLUTE_LINK_DOMAIN_STRIPPING_240201";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "./__internal__/getSetting";

export const getAbsoluteLinkDomainStripping = (): boolean => {
  return getSettingValueWithoutAssignment(
    ABSOLUTE_LINK_DOMAIN_STRIPPING_240201,
    false
  );
};

export const assignAbsoluteLinkDomainStripping = () =>
  assignSetting(ABSOLUTE_LINK_DOMAIN_STRIPPING_240201, {
    submitImmediately: true,
  });
